(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/poker/alias.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/poker/alias.js'); 'use strict';

svs.player_login.views.poker.Alias = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.empty(data);
  },

  initialize() {
    delete this.loader;
  },

  onAttach() {
    this.loader = new svs.components.Loader('.js-container');
    this.loader.show(300, 'inverted'); 

    svs.core.jupiter.call({
      path: '/player/1/customizedsettings',
      method: 'GET',
      context: this
    }, this.onGetAliasSuccess, this.aliasCheckComplete);
  },

  onGetAliasSuccess(data) {
    if (data.customizedSettings.properties.alias) {
      this.aliasCheckComplete();
    } else {
      svs.utils.form.postToUrl(svs.core.urlMapping.get('myProfileSetAliasPoker'), {
        returnUrl: svs.utils.url.currentPathEncodedParams()
      });
    }
  },

  aliasCheckComplete() {
    svs.utils.url.navigate("/poker/app/logga-in?returnUrl=".concat(encodeURIComponent(this.model.get('returnUrl')), "&at=").concat(encodeURIComponent(this.model.get('accessToken'))), true);
  }

});
 })(window);